import React, { PureComponent } from "react";
import OneColumnLayout from "../../layouts/one-column";
import CashFlowWidget from "../../../finance/widgets/cash-flow";

class TeamReportsSection7Step3 extends PureComponent {
  get content() {
    const { cashFlow, current_year } = this.props;

    return (
      <CashFlowWidget
        cashFlow={cashFlow}
        current_year={current_year}
        className="team-reports-with-scroll-2"
      />
    );
  }

  render() {
    return <OneColumnLayout title="Cash Flow" content={this.content} />;
  }
}

export default TeamReportsSection7Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-7/step-4.js